import {
  AfterViewInit,
  Component,
  ComponentRef, EventEmitter,
  Injector, Input,
  OnDestroy,
  OnInit, Output,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {NgxFilterBase} from "../../ngx-filter-base";
import {Filter} from "../../../ngx-types";

@Component({
  selector: 'ngx-number-filter',
  templateUrl: '../../ngx-filter-double-template-base.html'
})
export class NgxNumberFilterComponent extends NgxFilterBase implements OnInit, OnDestroy, AfterViewInit {

  startDate = new Date();

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  @Output() changeValue = new EventEmitter<any>();
  @Input() filter: Filter;

  get Label1(): string {
    // console.dir(this.filter.conditionOperator)
    if (this.filter.conditionOperator == this.conditionOperators.Between) {
      return this.minimumValue;
    } else {
      return this.amount;
    }
  }

  get Label2(): string {
    return this.maxLabel;
  }


  ngOnDestroy() {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    this.generateComponents(this.filterService.filtersComponent.numberBox, this.filter.options?.numberBoxOptions);
  }


  get maxLabel(): string {
    if (this.filter?.options?.numberBoxOptions?.maxLabel) {
      return this.filter.options.numberBoxOptions.maxLabel
    }
    return this.filterService.translator.maxLabel;
  }

  get minimumValue(): string {
    if (this.filter?.options?.numberBoxOptions?.minLabel) {
      return this.filter.options.numberBoxOptions.minLabel;
    }
    return this.filterService.translator.minimumLabel;
  }

  get amount(): string {
    if (this.filter?.options?.numberBoxOptions?.amountLabel) {
      return this.filter.options.numberBoxOptions.amountLabel
    }
    return this.filterService.translator.amountLabel;
  }

}
